import type { Sport } from '@/views/ValueDashboard/types';

/** Per-sport regulation-plus-buffer game length in ms. */
export const SPORT_GAME_DURATION_MS: Record<string, number> = {
  nba: 3 * 3_600_000,
  wnba: 2.5 * 3_600_000,
  nhl: 3 * 3_600_000,
  mlb: 4 * 3_600_000,
  cbb: 2.5 * 3_600_000,
  cfb: 4.5 * 3_600_000,
  atp: 4 * 3_600_000,
  wta: 3 * 3_600_000,
  ufc: 4 * 3_600_000,
  boxing: 6 * 3_600_000,
  esports: 4 * 3_600_000,
  cricket: 4.5 * 3_600_000,
  soccer: 2.5 * 3_600_000,
  nfl: 3.5 * 3_600_000,
};

export const GAME_FINAL_GRACE_MS = 30 * 60_000;

/** Status values hydra emits when a market reaches its terminal state.
 *  Hydra broadcasts the transition once per ticker then prunes ~5 min later
 *  (see HYDRA_API.md "Terminal state"). Used to drive `gameState='final'`
 *  on GameRow, the FINAL row treatment in GameTable, and the LT2
 *  line-availability classifier. */
export const TERMINAL_STATUSES = new Set(['closed', 'settled', 'finalized', 'determined']);

/** Statuses under which Kalshi accepts orders. Sports spread/total markets are
 *  observed in both (verified live 2026-05-12: WNBA spread/total ship as
 *  'active', NBA moneyline as 'open'). */
export const TRADABLE_STATUSES = new Set(['open', 'active']);

/** How old a market observation may be before its price stops being believable. */
export function marketStaleAfterMs(sport: Sport | string | null): number | null {
  if (sport == null) return null;
  const duration = SPORT_GAME_DURATION_MS[sport];
  return duration == null ? null : duration + GAME_FINAL_GRACE_MS;
}
